import axios from 'axios';

export default async (reference, documentType, personId) => {
  console.log({ reference, personId, documentType });
  const result = await axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/yoti/entity/${reference}/${documentType}/${personId}`,
  );
  return result.data;
};
